import VariantWishlist from "./VariantWishlist";
import { getURLParameter, handleize } from "../../Helpers/helpers";

export default class Wishlist {
    constructor(wishlist) {
        this.id = wishlist.id;
        this.label = wishlist.label;
        this.shared = wishlist.shared;
        this.totalPrice = 0.0;
        this.variants = wishlist.variants.map((variant) => new VariantWishlist(variant));
        this.isWishlistActive();
        this.updateSharedState();
        this.recalculateTotalPrice();
    }

    setShare(share) {
        this.share = share;
    }

    setActive(active) {
        this.active = active;
    }

    recalculateTotalPrice() {
        if (this.variants.length > 0) {
            this.totalPrice = this.variants.reduce((total, product) => total + parseFloat(product.price), 0.0);
        }
    }

    hasAllVariantsAvailable() {
        return this.variants.length === 0 || this.variants.every((variant) => variant.isAvailable());
    }

    getAvailableVariants() {
        return this.variants.filter((variant) => variant.isAvailable());
    }

    updateSharedState() {
        const wishlistIdFromUrl = getURLParameter("wishlist_id");
        const isShare = window.location.pathname.match(/^.*\/shared-wishlists$/g);
        if (parseInt(wishlistIdFromUrl) === this.id && isShare) {
            this.setShare(true);
        } else {
            this.setShare(false);
        }
    }

    isWishlistActive() {
        const wishlistIdFromUrl = getURLParameter("wishlist_id");
        this.setActive(!wishlistIdFromUrl || parseInt(wishlistIdFromUrl) === this.id);
    }

    getTotalPriceInPriceFormat() {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            currencySign: "accounting",
        }).format(this.totalPrice);
    }
}
